export { default as Dialog } from './src/Dialog'
